function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "#36458F"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.75 24.917c-1.06 0-1.917.858-1.917 1.916V34.5a1.919 1.919 0 01-1.916 1.917h-5.75V7.667c0-1.637-1.043-3.1-2.61-3.644l-.568-.19h8.928c1.058 0 1.916.86 1.916 1.917v5.75a1.916 1.916 0 103.834 0V5.75c0-3.17-2.58-5.75-5.75-5.75H4.312c-.072 0-.134.033-.205.042C4.015.035 3.927 0 3.833 0A3.837 3.837 0 000 3.833v34.5c0 1.637 1.043 3.1 2.61 3.644l11.535 3.845c.391.12.78.178 1.188.178a3.837 3.837 0 003.834-3.833V40.25h5.75c3.17 0 5.75-2.58 5.75-5.75v-7.667a1.916 1.916 0 00-1.917-1.916z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.438 17.812l-7.666-7.667A1.916 1.916 0 0034.5 11.5v5.75h-7.667a1.917 1.917 0 000 3.833H34.5v5.75a1.916 1.916 0 003.272 1.355l7.666-7.666c.75-.75.75-1.961 0-2.71z"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h46v46H0z"
})));

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.63bb9fe4.svg";
export { ForwardRef as ReactComponent };